import axios from "axios";
import { plainToInstance } from "class-transformer";
import { FeatureEnablementOverviewDto } from "healthex-common/global-admin-feature-enablement.dtos";
import { authenticatedApiConfig, generateURL } from "./BaseApiService";
export class GlobalAdminFeatureEnablementService {
    constructor(authenticationProvider, environment) {
        this.authenticationProvider = authenticationProvider;
        this.environment = environment;
    }
    async getOverview(organizationId, patientId) {
        const queryParams = {};
        if (organizationId) {
            queryParams.organizationId = organizationId;
        }
        if (patientId) {
            queryParams.patientId = patientId;
        }
        const response = await axios.get(generateURL(this.environment.API_BASE_URL, "/admin/feature-enablement"), await authenticatedApiConfig(this.authenticationProvider, queryParams));
        return plainToInstance(FeatureEnablementOverviewDto, response.data);
    }
    async updateGlobalFeature(input) {
        await axios.put(generateURL(this.environment.API_BASE_URL, "/admin/feature-enablement/global"), input, await authenticatedApiConfig(this.authenticationProvider));
    }
    async updateOrganizationFeature(organizationId, input) {
        await axios.put(generateURL(this.environment.API_BASE_URL, "/admin/feature-enablement/organizations/:organizationId", { organizationId }), input, await authenticatedApiConfig(this.authenticationProvider));
    }
    async updatePatientFeature(patientId, input) {
        await axios.put(generateURL(this.environment.API_BASE_URL, "/admin/feature-enablement/patients/:patientId", { patientId }), input, await authenticatedApiConfig(this.authenticationProvider));
    }
}
